import { IsBoolean, IsOptional, IsUUID } from 'class-validator';

/**
 * Body for `POST /admin/iot/gateways/:id/update-firmware`.
 * The gateway must be online (503 if not — OTA is intrinsically live).
 * Anti-downgrade: rejected unless `firmware.version > gateway.firmwareVersion`,
 * unless `force: true`.
 */
export class UpdateIotGatewayFirmwareDto {
  @IsUUID()
  firmwareId!: string;

  @IsOptional()
  @IsBoolean()
  force?: boolean;
}
